import { lazy } from 'react';

const BillingComplete = lazy(() => import('../../pages/Billing/BillingComplete'));

export const billingRoutes = [{ path: '/billing/complete', element: <BillingComplete /> }];
